import styled from "styled-components";
import { theme } from "@themes";

export const ImgLogoTPHomeMenu = styled.div`
  content: url(${(props) => props.srclogo});
  width: 18vw;
  height: auto;
  @media only screen and (max-width: 700px) {
    width: 100px;
    height: 35px;
  }
`;

export const LogoContainer = styled.div`
  height: 25%;
  display: flex;
  justify-content: center;
`;
export const FormContainer = styled.div`
  height: 75%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
`;

export const ImgLogo = styled.div`
  background-image: ${({ logo }) => (logo ? `url(${logo})` : "inherit")};
  background-repeat: no-repeat;
  width: 14.641vw;
  height: 39.57px;
  min-width: 80px;
  background-size: contain;
  max-width: 200px;
  max-height: 39.57px;
  position: relative;
  display: flex;
  justify-self: center;
  @media (min-width: 1800px) {
    width: 29em;
    height: 6em;
  }
  @media (min-width: 1280px) {
    width: 16em;
    height: 6em;
  }
  @media (max-width: 768px) {
    width: 112px;
    height: 30px;
  }
`;

export const Buttonlogin = styled.button`
  position: relative;
  background: ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 600;
  font-size: 1.171vw;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 70%;
  height: 3.221vw;
  max-width: 270px;
  max-height: 41px;
  margin: 0px auto;
  @media (min-width: 2000px) {
    font-size: 16px;
  }
`;

export const LoginContent = styled.div`
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-columns: 30% 70%;
  @media (max-width: 1023px) {
    grid-template-columns: 100%;
  }
`;

export const LeftPanel = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  z-index: 1;
`;
export const RightPanel = styled.div`
  background: ${({ theme }) => theme.primary.gradient};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  img {
    margin-left: -13em;
    @media (max-width: 1023px) {
      display:none;
    }
  }
`;

export const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1em;
  margin: auto;
  grid-auto-rows: 1em auto;
  align-items: center;
  width: 70%;
  max-width: 270px;
  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 1.025vw;
    @media (min-width: 2000px) {
      font-size: 14px;
    }
    @media (max-width: 768px) {
      font-size: 6px;
    }
  }
  input,
  select {
    padding: 0.5em;
    grid-column: 1/3;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 1.025vw;
    color: ${({ theme }) => theme.primary.purple};
    @media (min-width: 2000px) {
      font-size: 14px;
    }
    @media (max-width: 768px) {
      height: 20px;
    }
  }
  input::placeholder {
    font-size: 0.878vw;
    @media (min-width: 2000px) {
      font-size: 12px;
    }
  }
`;
export const ContentTermsConditions = styled.div`
  width: 100%;
  font-size: 11px;
  display: flex;
  justify-content: center;
  letter-spacing: 0.16px;
  text-align: center;
  color: ${({ theme }) => theme.text.primary};
  line-height: normal;
  @media (min-width: 2000px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    font-size: 12px;
  }
  span {
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    width: 80%;
  }
`;
export const ContentTerm = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  width: 48vw;
  margin: 4vh auto;
  display: grid;
`;
export const InfoTermsAndConditions = styled.div`
  padding: 2em;
  height: 84vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[950]};
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.border.purpleLight};
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.neutral.white}73;
    border-radius: 10px;
  }
`;
export const HeaderContentTerm = styled.div`
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[1400]};
  div {
    float: left;
    font-size: 16px;
    color: ${({ theme }) => theme.neutral.gray[2200]};
    font-weight: 700;
  }
  svg {
    float: right;
    cursor: pointer;
  }
`;

export const VersionContainer = styled.div`
  display: flex;
  font-size: 10px;
  justify-content: end;
  padding-right: 10px;
`;
export const BoxContainer = styled.div`
  width: 90%;
  border: 1px solid ${({ theme }) => theme.neutral.gray[1300]};
  min-height: 180px;
  margin-bottom: 24px;
`;

export const UserInfoContainer = styled.div`
  position: absolute;
  top: 20px;
  margin: 10px;
`;
